module.exports = __webpack_public_path__ + "media/images/element/google-play-66a492037c70de48cbb58b2e285b5fc8.svg";